const filterFacetOption = (item, facet) => {
  if (!facet.forceOptions) {
    return true;
  }
  const optionsAllowed = facet.options ? Object.keys(facet.options) : [];
  return optionsAllowed.includes(item.label);
};
export {
  filterFacetOption
};
//# sourceMappingURL=filter-facet-option.js.map
